/** Parent pages can listen: `window.addEventListener('message', (e) => { if (e.data?.type === EMEDISKILL_NAVIGATE_MESSAGE && e.data.href) location.href = e.data.href })` */
export const EMEDISKILL_NAVIGATE_MESSAGE = 'EMEDISKILL_NAVIGATE' as const;

/** Parent pages can listen: `window.addEventListener('message', (e) => { if (e.data?.type === EMEDISKILL_EXTEND_COURSE_MESSAGE) openExtendFlow(e.data.payload) })` */
export const EMEDISKILL_EXTEND_COURSE_MESSAGE = 'EMEDISKILL_EXTEND_COURSE' as const;

/** Parent pages can listen: `window.addEventListener('message', (e) => { if (e.data?.type === EMEDISKILL_OPEN_CHAT_MESSAGE) openChat() })` */
export const EMEDISKILL_OPEN_CHAT_MESSAGE = 'EMEDISKILL_OPEN_CHAT' as const;

/**
 * When this app runs inside an iframe, normal navigation only affects the iframe.
 * Same-origin parent: assign `window.top.location`. Cross-origin: `postMessage` to parent.
 */
export function navigateParentWindowFromIframe(href: string) {
    if (typeof window === 'undefined' || !href) return;
    try {
        window.top!.location.href = href;
    } catch {
        const targetOrigin = process.env.REACT_APP_PARENT_POSTMESSAGE_ORIGIN || '*';
        window.parent.postMessage(
            { type: EMEDISKILL_NAVIGATE_MESSAGE, href },
            targetOrigin
        );
    }
}

/**
 * Notify the parent window (main site hosting this iframe) to start the
 * "extend course duration" flow for the given course. Safe to call even when
 * not inside an iframe — it just no-ops because `window.parent === window`.
 */
export function notifyParentToExtendCourse(payload: Record<string, any>) {
    if (typeof window === 'undefined') return;
    const targetOrigin = process.env.REACT_APP_PARENT_POSTMESSAGE_ORIGIN || '*';
    window.parent.postMessage(
        { type: EMEDISKILL_EXTEND_COURSE_MESSAGE, payload },
        targetOrigin
    );
}

/** Ask the parent site to open its chat widget. */
export function notifyParentToOpenChat() {
    if (typeof window === 'undefined') return;
    const targetOrigin = process.env.REACT_APP_PARENT_POSTMESSAGE_ORIGIN || '*';
    window.parent.postMessage(
        { type: EMEDISKILL_OPEN_CHAT_MESSAGE },
        targetOrigin
    );
}

/**
 * Go to a URL on the main marketing site: uses the top window when embedded in an iframe,
 * otherwise assigns `window.location` in the current window.
 */
export function navigateToMainSite(href: string) {
    // if (typeof window === 'undefined' || !href) {
    //     console.log("navigateToMainSite not found window or href", href);
    //     return;}
    // if (window.self === window.top) {
    //     window.location.href = href;
    //     return;
    // }
    navigateParentWindowFromIframe(href);
}
